import React, {useMemo} from "react";
import {Text, Divider, Stack} from "@nike/podium";
import {ImbalanceItem} from "../../common/data/types";

type SummaryStripProps = {
    items: ImbalanceItem[];
    monthLabel: string;
    totalCount: number | null;
    persistOnly: boolean;
};

export function SummaryStrip({items, monthLabel, totalCount, persistOnly}: SummaryStripProps) {
    const stats = useMemo(() => ({
        shown: items.length,
        zero: items.filter(item => item.direction === 'WMS_0').length,
        under: items.filter(item => item.direction === 'WMS_LESS_THAN_CI').length,
        over: items.filter(item => item.direction === 'WMS_MORE_THAN_CI').length,
    }), [items]);

    const sinceLabel = persistOnly ? `Since ${monthLabel}` : 'Total imbalances';

    return (
        <Stack horizontal align="center" gap="l" className="im-summary-row">
            <Stack gap="xs">
                <Text font="body-4" color="secondary">Lines shown</Text>
                <Text font="title-4" as="span">{stats.shown}</Text>
            </Stack>
            <Divider vertical />
            <Stack gap="xs">
                <Text font="body-4" color="secondary">WMS = 0</Text>
                <Text font="title-4" as="span">{stats.zero}</Text>
            </Stack>
            <Divider vertical />
            <Stack gap="xs">
                <Text font="body-4" color="secondary">WMS &lt; CI</Text>
                <Text font="title-4" as="span">{stats.under}</Text>
            </Stack>
            <Divider vertical />
            <Stack gap="xs">
                <Text font="body-4" color="secondary">WMS &gt; CI</Text>
                <Text font="title-4" as="span">{stats.over}</Text>
            </Stack>
            <Divider vertical />
            <Stack gap="xs">
                <Text font="body-4" color="secondary">{sinceLabel}</Text>
                <Text font="title-4" as="span">{totalCount !== null ? totalCount : '—'}</Text>
            </Stack>
        </Stack>
    );
}
